const t = "{{currentTime}} av {{duration}}", n = "Søkeresultat {{current}} av {{total}}", s = "Ingen resultater ble funnet", e = "{{count}} resultat funnet", o = "{{count}} resultater funnet", r = 'Spiller fra $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', A = 'Spiller fra $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', E = 'Spiller fra $t(SECONDS, { "count": {{seconds}} }).', T = "Feil ved lagring av endringer i transkripsjonen.", c = "Transkripsjonslinje ved {{time}}. Innhold er: {{text}}.", S = 'Beholder for transkripsjonslinjer. Det er $t(TRANSCRIPT_LINES, { "count": {{count}} }) i denne beholderen. Bruk pil ned for å navigere i denne beholderen.', i = "Lagrer endringer …", _ = "Endringer lagret til transkripsjon.", l = "Knappen for å oppdatere teksting er nå tilgjengelig.", N = "Handling", R = "Legg til merknad på {{time}}", I = "Legg til spørsmål {{time}}", O = "Merknader", a = "Auto", C = "Auto ({{quality}})", u = "Tilbake", k = "Teksting", P = "Tekst-språk", p = "Administrer teksting", L = "Slett {{language}}", U = "Skriftstørrelse", g = "Tekst-språk: {{language}}", D = "{{language}} (automatisk)", d = "Tøm søkefelt", M = "Lukk", m = "Kommentarer", v = "Fortsett", G = "Reduser avspillingshastighet", Y = "Reduser volum med {{percent}}%", j = "Pil ned", h = "Lukk trankripsjonsredigerer", H = "Oppdater teksting", f = "Feil!", V = "Lagrer …", B = "Lagret!", F = "Rediger transkripsjon", K = "Tekstfeltet kan ikke være tomt!", b = "Fullskjerm", y = "{{count}} time", W = "{{count}} timer", $ = "Øk avspillingshastighet", Q = "Øk volum med {{percent}}%", J = "Inverter farger", q = "Hopp til spesifikk prosentandel (1–10 %, 2–20 % osv.)", x = "Hopp til start", Z = "Aksjonspunkter for {{title}}", z = "Snarveier", X = "Språk", w = "Venstre pil", tt = "Hovedmeny", nt = "{{count}} minutt", st = "{{count}} minutter", et = "Demp", ot = "Skjult", rt = "Neste tekst-språk", At = "Neste søkeresultat", Et = "Av", Tt = "Øverst", ct = "Åpne merknader på {{time}}", St = "Åpne fullførte quizer på {{time}}", it = "Åpne quizer på {{time}}", _t = "Pause", lt = "Spill av", Nt = "Avspillingshastighet", Rt = "Avspillingshastighet: {{speed}}x", It = "Forrige tekst-språk", Ot = "Forrige søkeresultat", at = "Kvalitet", Ct = "Kvalitetsmeny", ut = "Spill på nytt", kt = "Tilbakestill avspillingshastighet", Pt = "Høyre pil", pt = "Søk i transkripsjon", Lt = "{{count}} sekund", Ut = "{{count}} sekunder", gt = "Søk bakover: {{seconds}} sekunder", Dt = "Søk forover: {{seconds}} sekunder", dt = "Innstillinger", Mt = "Snarvei", mt = "Mediedetaljer og verktøy", vt = "Mellomrom", Gt = "Avspillingshastighet-meny", Yt = "Start Autoscroll", jt = "Slå på/av teksting", ht = "Slå på/av demping", Ht = "Spill av/pause", ft = "er {{count}} transkripsjonslinje", Vt = "er {{count}} transkripsjonslinjer", Bt = "Laster inn transkripsjon …", Ft = "Vi kunne ikke laste inn transkripsjonen.", Kt = "Transkripsjonsalternativer", bt = "Prøv igjen", yt = "Transkripsjon utilgjengelig", Wt = "Pil opp", $t = "Videoinnstillinger", Qt = "Volum", Jt = "Volum: {{volume}}%", qt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: s,
  A11Y_SEARCH_RESULTS_FOUND: e,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: r,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: E,
  A11Y_TRANSCRIPT_ERROR: T,
  A11Y_TRANSCRIPT_LINE: c,
  A11Y_TRANSCRIPT_LINES: S,
  A11Y_TRANSCRIPT_SAVING: i,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: l,
  ACTION: N,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: I,
  ANNOTATIONS: O,
  AUTO: a,
  AUTO_QUALITY: C,
  BACK: u,
  CAPTIONS: k,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: p,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: U,
  CAPTION_LANGUAGE: g,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: d,
  CLOSE: M,
  COMMENTS: m,
  CONTINUE: v,
  DECREASE_PLAYBACK_SPEED: G,
  DECREASE_VOLUME: Y,
  DOWN_ARROW: j,
  EDIT_CLOSE: h,
  EDIT_CONFIRM: H,
  EDIT_ERROR: f,
  EDIT_SAVING: V,
  EDIT_SUCCESS: B,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: b,
  HOURS: y,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: Q,
  INVERT_COLORS: J,
  JUMP_TO_PERCENTAGE: q,
  JUMP_TO_START: x,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: z,
  LANGUAGE: X,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: st,
  MUTE: et,
  MUTED: ot,
  NEXT_CAPTION_LANGUAGE: rt,
  NEXT_HIT: At,
  OFF: Et,
  ON_TOP: Tt,
  OPEN_ANNOTATION_AT: ct,
  OPEN_COMPLETED_QUIZ_AT: St,
  OPEN_QUIZ_AT: it,
  PAUSE: _t,
  PLAY: lt,
  PLAYBACK_SPEED: Nt,
  PLAYBACK_SPEED_MESSAGE: Rt,
  PREVIOUS_CAPTION_LANGUAGE: It,
  PREVIOUS_HIT: Ot,
  QUALITY: at,
  QUALITY_MENU: Ct,
  REPLAY: ut,
  RESET_PLAYBACK_SPEED: kt,
  RIGHT_ARROW: Pt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: pt,
  SECONDS: Lt,
  SECONDS_other: Ut,
  SEEK_BACKWARD: gt,
  SEEK_FORWARD: Dt,
  SETTINGS: dt,
  SHORTCUT: Mt,
  SIDEBAR: mt,
  SPACE: vt,
  SPEED_MENU: Gt,
  START_AUTOSCROLL: Yt,
  TOGGLE_CAPTIONS: jt,
  TOGGLE_MUTED: ht,
  TOGGLE_PLAY_PAUSE: Ht,
  TRANSCRIPT_LINES: ft,
  TRANSCRIPT_LINES_other: Vt,
  TRANSCRIPT_LOADING: Bt,
  TRANSCRIPT_LOAD_ERROR: Ft,
  TRANSCRIPT_OPTIONS: Kt,
  TRANSCRIPT_RETRY: bt,
  TRANSCRIPT_UNAVAILABLE: yt,
  UP_ARROW: Wt,
  VIDEO_SETTINGS: $t,
  VOLUME: Qt,
  VOLUME_VALUE: Jt
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  s as A11Y_SEARCH_NO_RESULTS,
  e as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  r as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  E as A11Y_TIMESTAMP_JUMP_SECONDS,
  T as A11Y_TRANSCRIPT_ERROR,
  c as A11Y_TRANSCRIPT_LINE,
  S as A11Y_TRANSCRIPT_LINES,
  i as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  l as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  R as ADD_ANNOTATION_AT,
  I as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  a as AUTO,
  C as AUTO_QUALITY,
  u as BACK,
  k as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  p as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  U as CAPTION_FONT_SIZE,
  g as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  d as CLEAR_SEARCH,
  M as CLOSE,
  m as COMMENTS,
  v as CONTINUE,
  G as DECREASE_PLAYBACK_SPEED,
  Y as DECREASE_VOLUME,
  j as DOWN_ARROW,
  h as EDIT_CLOSE,
  H as EDIT_CONFIRM,
  f as EDIT_ERROR,
  V as EDIT_SAVING,
  B as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  b as FULLSCREEN,
  y as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  Q as INCREASE_VOLUME,
  J as INVERT_COLORS,
  q as JUMP_TO_PERCENTAGE,
  x as JUMP_TO_START,
  Z as KEBAB_MENU,
  z as KEYBOARD_SHORTCUTS,
  X as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  st as MINUTES_other,
  et as MUTE,
  ot as MUTED,
  rt as NEXT_CAPTION_LANGUAGE,
  At as NEXT_HIT,
  Et as OFF,
  Tt as ON_TOP,
  ct as OPEN_ANNOTATION_AT,
  St as OPEN_COMPLETED_QUIZ_AT,
  it as OPEN_QUIZ_AT,
  _t as PAUSE,
  lt as PLAY,
  Nt as PLAYBACK_SPEED,
  Rt as PLAYBACK_SPEED_MESSAGE,
  It as PREVIOUS_CAPTION_LANGUAGE,
  Ot as PREVIOUS_HIT,
  at as QUALITY,
  Ct as QUALITY_MENU,
  ut as REPLAY,
  kt as RESET_PLAYBACK_SPEED,
  Pt as RIGHT_ARROW,
  pt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Lt as SECONDS,
  Ut as SECONDS_other,
  gt as SEEK_BACKWARD,
  Dt as SEEK_FORWARD,
  dt as SETTINGS,
  Mt as SHORTCUT,
  mt as SIDEBAR,
  vt as SPACE,
  Gt as SPEED_MENU,
  Yt as START_AUTOSCROLL,
  jt as TOGGLE_CAPTIONS,
  ht as TOGGLE_MUTED,
  Ht as TOGGLE_PLAY_PAUSE,
  ft as TRANSCRIPT_LINES,
  Vt as TRANSCRIPT_LINES_other,
  Bt as TRANSCRIPT_LOADING,
  Ft as TRANSCRIPT_LOAD_ERROR,
  Kt as TRANSCRIPT_OPTIONS,
  bt as TRANSCRIPT_RETRY,
  yt as TRANSCRIPT_UNAVAILABLE,
  Wt as UP_ARROW,
  $t as VIDEO_SETTINGS,
  Qt as VOLUME,
  Jt as VOLUME_VALUE,
  qt as default
};
